import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import authService from '../../services/authService';
import { OidcState } from '../../interfaces';
import { Box } from '@mui/material';

export default function SigninOidc() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        authService.signinRedirectCallback()
            .then(function (user) {
                const oidcState = user.state as OidcState;
                navigate(oidcState.returnUrl);
            })
            .catch(function (e) {
                const error: string = e as string;
                if (error == "ErrorResponse: Forbidden"
                        || error == "ErrorResponse: NotFound"
                        || error == "Error: No matching state found in storage"
                        || searchParams.get("error") == "forbidden"
                        || searchParams.get("error") == "unauthorized"
                        || searchParams.get("error") == "access_denied") {
                    navigate('/access-deny');
                }
            });
    }, []);

    return (
        <React.Fragment>
            <Box>Signing in...</Box>
        </React.Fragment>
    );
}
